import { createSlice } from '@reduxjs/toolkit';

const CART_KEY = 'mg_cart';

const loadCart = () => {
  try {
    const saved = localStorage.getItem(CART_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (_) {
    return [];
  }
};

const saveCart = (items) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  } catch (_) {}
};

const CartSlice = createSlice({
  name: 'Cart',
  initialState: {
    items: loadCart(),
  },
  reducers: {
    addToCart: (state, action) => {
      const { product, variant = null, quantity = 1 } = action.payload;
      const key = variant ? `${product.id}-v${variant.id}` : `${product.id}`;
      const existing = state.items.find((i) => i.key === key);

      if (existing) {
        existing.qty += quantity;
      } else {
        const price = Number(variant?.discount_price || product.discount_price) || 0;
        const mrp   = Number(variant?.price || product.price) || 0;
        state.items.push({
          key,
          id:          product.id,
          slug:        product.slug,
          title:       product.title,
          image:       variant?.image || product.thumbnail,
          variantId:   variant?.id   || null,
          variantInfo: variant ? `${variant.label}: ${variant.value}` : null,
          price,
          mrp,
          qty:         quantity,
        });
      }
      saveCart(state.items);
    },

    removeFromCart: (state, action) => {
      state.items = state.items.filter((i) => i.key !== action.payload);
      saveCart(state.items);
    },

    updateQty: (state, action) => {
      const { key, qty } = action.payload;
      if (qty <= 0) {
        state.items = state.items.filter((i) => i.key !== key);
      } else {
        const item = state.items.find((i) => i.key === key);
        if (item) item.qty = qty;
      }
      saveCart(state.items);
    },

    clearCart: (state) => {
      state.items = [];
      saveCart([]);
    },
  },
});

export const { addToCart, removeFromCart, updateQty, clearCart } = CartSlice.actions;

// Selectors
export const selectCartItems  = (state) => state.Cart.items;
export const selectCartCount  = (state) => state.Cart.items.reduce((s, i) => s + i.qty, 0);
export const selectCartTotal  = (state) =>
  state.Cart.items.reduce((s, i) => s + i.price * i.qty, 0);

export default CartSlice.reducer;
